export { default } from "./ShopNavigationTiles";
